module.exports = __webpack_public_path__ + "img/code-vue-md.7810f257.webp";